import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../../shared/services/httpclient.service";
import { StudentRegRequest } from "./StudentRegRequest";
import { StudentListParentRequest } from "./StudentListParentRequest";

@Injectable()
export class DataService_NotifyReport {
	constructor(private httpclientService: HttpclientService) {}

	PrintStudentRegReport(parms: StudentRegRequest) {
		var postResult$ = new Subject();
		var url = "NotifyReport/PrintStudentRegReport";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	PrintStudentListParentsReport(parms: StudentListParentRequest) {
		var postResult$ = new Subject();
		var url = "NotifyReport/PrintStudentListParentsReport";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	PrintParentListStudentsReport(parms: StudentListParentRequest) {
		var postResult$ = new Subject();
		var url = "NotifyReport/PrintParentListStudentsReport";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}
}
